import { createSlice } from '@reduxjs/toolkit';
import { ANALYTICS } from '../../actions/AnalyticsReports/actionTypes';

const analyticsInitialState = {
    analytics: {
    reportList: [],
    analyticsReport: [],
    isLoading: false,
    errors: ''
  }
};

export const analyticsSlice = createSlice({
  name: ANALYTICS,
  initialState: analyticsInitialState,
  reducers: {
    /* This action will trigger our saga middleware
       and set the loader to true and reset error message.
    */
    getAnalyticsReportListAction: (state,) => {
        state.isLoading = true;
        state.analytics.errors = '';
      },
      getAnalyticsReportListSuccessAction: (state, action) => {
        state.analytics.isLoading = false;
        state.analytics.reportList = action.payload;
      },
      
      getAnalyticsReportListFailureAction: (state, action) => {
        state.analytics.isLoading = false;
        state.analytics.errors = action.payload;
      },
      getAnalyticsAnalyticsReportAction: (state,) => {
        state.isLoading = true;
        state.analytics.errors = '';
      },
      getAnalyticsAnalyticsSuccessReportAction: (state, action) => {
        state.analytics.isLoading = true;
        state.analytics.analyticsReport = action.payload;
      },
      getAnalyticsAnalyticsFailureReportAction: (state, action) => {
        state.analytics.isLoading = false;
        state.analytics.errors = action.payload;
      }
  }
});

/* getUserSuccessAction and getUserErrorAction will be used inside the saga
  middleware. Only getUserAction will be used in a React component.
*/

export const { getAnalyticsReportListAction, getAnalyticsAnalyticsReportAction,getAnalyticsReportListSuccessAction,getAnalyticsReportListFailureAction,getAnalyticsAnalyticsSuccessReportAction,getAnalyticsAnalyticsFailureReportAction } = analyticsSlice.actions;
export default analyticsSlice.reducer;
